export const QUALITY = {
  high: { ratio: 1.5, shadows: true, idle: true, gloss: true, post: true, dof: true, bloom: true },
  balanced: { ratio: 1.25, shadows: false, idle: false, gloss: false, post: true, dof: true, bloom: true },
  low: { ratio: 1, shadows: false, idle: false, gloss: false, post: false, dof: false, bloom: false },
};
export function effectiveQuality(preference, mobile, slow = false) {
  if (QUALITY[preference]) return preference;
  return mobile || slow ? "low" : "balanced";
}
